import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  BaseEntity,
  Button,
  ColumnLayout,
  confirm,
  Form,
  FormField,
  Modal,
  ModalHeader,
  ModalBody,
  translate
} from "clavis-nxt-components-custdevtm";
import { ConfigurationEntity } from "../../domain/ConfigurationEntity/ConfigurationEntity";
import "./AddOrModifyModal.scss";

class AddOrModifyModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      entity: props.entity ? props.entity : new ConfigurationEntity()
    };
  }

  insert = formProps => {
    formProps
      .insert(this.state.entity)
      .promise.then(() => this.props.toggle("isOpenAddOrModify", null, true));
  };

  update = formProps => {
    formProps
      .update(this.state.entity)
      .promise.then(() => this.props.toggle("isOpenAddOrModify", null, true));
  };

  required = value => {
    const { t } = this.props;
    if (!value && value !== 0) {
      return [t("modal.addOrModify.required")];
    }
  };

  render() {
    const { t } = this.props;
    return (
      <Modal
        centered
        className={"add-or-modify-modal"}
        isOpen={this.props.isOpen}
        size={"lg"}
      >
        <ModalHeader toggle={() => this.props.toggle("isOpenAddOrModify")}>
          {t(
            this.props.entity
              ? "modal.addOrModify.title.modify"
              : "modal.addOrModify.title.add"
          )}
        </ModalHeader>
        <ModalBody>
          <Form
            entity={this.state.entity}
            onChange={entity => this.setState({ entity: entity })}
            render={formProps => (
              <div>
                <ColumnLayout width={3}>
                  <FormField
                    description={t("modal.addOrModify.required")}
                    property={"confKey"}
                    title={t("entity.ConfigurationEntity.property.confKey")}
                    validate={this.required}
                  />
                  <FormField
                    description={t("modal.addOrModify.required")}
                    property={"confValue"}
                    title={t("entity.ConfigurationEntity.property.confValue")}
                    validate={this.required}
                  />
                  <FormField
                    property={"confDesc"}
                    title={t("entity.ConfigurationEntity.property.confDesc")}
                  />
                  <FormField
                    property={"moduleCode"}
                    title={t("entity.ConfigurationEntity.property.moduleCode")}
                  />
                </ColumnLayout>
                <div className={"button-container"}>
                  <Button
                    buttonType={"custom"}
                    classes={
                      "button-text-color secondary-inverted-background-color"
                    }
                    click={() => this.props.toggle("isOpenAddOrModify")}
                  >
                    {t("modal.addOrModify.button.cancel")}
                  </Button>
                  <Button
                    buttonType="primary"
                    click={() => {
                      formProps.setTouchedForm();
                      if (formProps.valid) {
                        this.props.entity
                          ? this.update(formProps)
                          : this.insert(formProps);
                      }
                    }}
                    disabledButton={!formProps.valid && formProps.touchedForm}
                  >
                    {t(
                      this.props.entity
                        ? "modal.addOrModify.button.modify"
                        : "modal.addOrModify.button.add"
                    )}
                  </Button>
                </div>
              </div>
            )}
          />
        </ModalBody>
      </Modal>
    );
  }
}

AddOrModifyModalComponent.propTypes = {
  // Instance of ConfigurationEntity (only modify)
  entity: PropTypes.instanceOf(BaseEntity),
  // Boolean to control the state of the modal
  isOpen: PropTypes.bool.isRequired,
  // Callback for toggling isOpen in the controlling component
  toggle: PropTypes.func.isRequired
};

AddOrModifyModalComponent.defaultProps = {
  entity: null,
  isOpen: false
};

export const AddOrModifyModal = translate()(confirm(AddOrModifyModalComponent));
